module.exports = __webpack_public_path__ + "img/content6-4.4a32c8eb.webp";